import { CreateCaseModal } from '@lp/features/modals';
import { CaseBoardDuplicates } from './components/CasesBoardDuplicates';
import { ActiveCases } from './components/ActiveCases/ActiveCases';

export const CasesBoardControlPanel = () => {
  return (
    <div className="flex items-center">
      <ActiveCases />
      <CaseBoardDuplicates />
      <CreateCaseModal />
    </div>
  );
};
